/*
 * @Date: 2023-10-27 11:20:13
 * @LastEditors: lihwang_wf@126.com
 * @LastEditTime: 2023-11-24 16:12:46
 * @FilePath: /Client/src/util/useService.ts
 * @Description:
 */
import { Site } from '@/common/const'
import { isJA, isKO, isEN } from '@/store'
import { useStore } from 'vuex'

// function appendServicePersonFn (): void {
//   const w: any = window
//   const ch: any = function (...rest: any) {
//     ch.c(rest)
//   }
//   ch.q = []
//   ch.c = function (args: any) {
//     ch.q.push(args)
//   }
//   w.ChannelIO = ch

//   function l () {
//     if (w.ChannelIOInitialized) {
//       return
//     }
//     w.ChannelIOInitialized = true
//     const s = document.createElement('script')
//     s.type = 'text/javascript'
//     s.async = true
//     s.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js'
//     const x: any = document.getElementsByTagName('script')[0]
//     x.parentNode.insertBefore(s, x)
//   }
//   if (document.readyState === 'complete') {
//     l()
//   } else {
//     window.addEventListener('DOMContentLoaded', l, false)
//     window.addEventListener('load', l, false)
//   }
// }

interface ChatWindowParam {
  name: string;
  width?: number;
  height?: number;
  features?: string;
  maxWidth?: number;
  maxHeight?: number;
  bgColor?: string;
  bgImage?: string;
  bgRepeat?: 0 | 1 | 2;
}

interface EchatParams {
 // 对话入口参数
 echatTag?: string;

 // 指定语言
 lan?: string;

 // 会员加密身份信息
 metaData?: string;

 // 自定义业务数据
 myData?: string;

 // 实现 app 推送的自定义参数
 pushInfo?: string;

 // 咨询入口 id
 routeEntranceId?: string;

 // 图文消息
 visEvt?: string;

 // 是否支持上传多张图片
 multipleFile?: '0' | '1';

 // PC 新页面或新窗口打开对话时设置的窗口参数
 chatWindowParam?: ChatWindowParam;

 // 指派接待客服
 acdStaffId?: number;

 // 分配优先级
 acdType?: 0 | 1;

 // 业务主题数据
 formData?: string;

 // 发起对话并发送一条消息
 fm?: any; // 这里可以更具体地定义消息类型

 // 来源标识
 launchfrom?: string;

 // 访客手机端对话界面链接打开方式
 echatIframeDisable?: number;

 /* PC 端对话窗口样式 */
 template?: number;

}

const start = (userVipInfo: any = null) => {
  // if (['signin', 'signup', 'login', 'login_h5', 'signup_h5', 'findpwd'].some(i => location.pathname.includes(i))) return
  // todo:用户名
  const w: any = window
  // w._echat('initParam', { companyId: 100, lan: 'ja' })
  // w._echat.customMiniChat({ echatTag: 'order' })

  // const pluginKey = isJA() ? '9ef7076e-b606-45f8-bb06-ec8b98b5fc7f' : isKO() ? 'a8abba3a-e7bc-4c8f-be7f-dba4a6267063' : isEN() ? 'f0de67e2-2b39-4af5-85e6-3001b7ebcc75' : '9ef7076e-b606-45f8-bb06-ec8b98b5fc7f' // 默认日本的客服key

  // w.ChannelIO('shutdown')
  // 如果用户已登录状态
  // if (userVipInfo) {
  //   w.ChannelIO('boot', {
  //     pluginKey: pluginKey,
  //     memberId: userVipInfo.customerId,
  //     profile: {
  //       systemName: userVipInfo.loginName,
  //       systemEmail: userVipInfo.customerEmail,
  //       templateName: userVipInfo.membership?.membershipTemplateName,
  //       systemMemberId: userVipInfo.customerId,
  //       name: userVipInfo.loginName,
  //       email: location.href
  //     }
  //   })
  // } else {
  //   w.ChannelIO('boot', {
  //     pluginKey: pluginKey,
  //     profile: {
  //       systemName: null,
  //       systemEmail: null,
  //       templateName: null,
  //       systemMemberId: null,
  //       name: null,
  //       email: null
  //     }
  //   })
  // }
  // w.ChannelIO('hideChannelButton')
}
// appendServicePersonFn()

export default start

export const toggleService = (a:any) => {}

// export const toggleService = (name: any) => {
//   const el = document.getElementById('ch-plugin')
//   // 隐藏首页客服按钮
//   setTimeout(() => {
//     const gtx:any = document.querySelector('#ch-plugin div:last-child')
//     const style:any = document.createElement('style')
//     if (['signin', 'signup', 'login', 'login_h5', 'signup_h5', 'findpwd'].includes(name)) {
//       if (gtx) gtx.style.cssText += 'position: absolute !important'
//     } else {
//       if (gtx) gtx.style.cssText += 'position: static !important'
//     }
//     style.innerHTML = '.keQiqC { position: absolute !important; right: -300px !important;  z-index:1000 !important} .hVIjnB{ right: 280px !important; top: -227px !important; min-width:16px !important; height:16px!important; z-index:1000 !important}'
//     if (gtx?.shadowRoot) gtx.shadowRoot.appendChild(style)
//   }, 280)
// }
